import { styled, component } from '../../../../utils/style';
import { StyleColor } from '../../../../utils/styles-constants';


interface StyledMenuItemProps {
	isActive?: boolean;
	isBold?: boolean;
}

export const StyledMenuItem = styled<StyledMenuItemProps>()(component.a, 'StyledMenuItem')`
	display: flex;
	align-items: center;
	color: ${StyleColor.Grey650};
	font-weight: ${ props => props.isActive || props.isBold ? 'bold' : 'normal'};
	background-color: ${ props => props.isActive ? StyleColor.Grey100 : StyleColor.Grey50};
	border-bottom: 1px solid ${StyleColor.Grey100};
	padding: 15px;
	text-decoration: none;
	cursor: pointer;

	> img {
		max-height: 30px;
		max-width: 100%;
		min-width: 30px;
		margin-right: 15px;
		flex-shrink: 0;
	}

	> svg {
		height: 30px;
		width: 30px;
		margin-right: 15px;
		flex-shrink: 0;
		fill:${ props => props.isActive || props.isBold ? StyleColor.Grey600 : StyleColor.Grey500};
	}

	@media (hover: hover) {
		&:hover {
			background-color: ${StyleColor.Grey100};

			> svg {
				fill: ${StyleColor.Grey600};
			}
		}
	}
`;

export const MenuItemBadge = styled()(component.div, 'MenuItemBadge')`
	width: 22px;
	height: 22px;
	display: flex;
	flex-wrap: wrap;
	font-size: 12px;
	align-items: center;
	align-content: center;
	border-radius: 50%;
	flex-direction: row;
	justify-content: center;
	margin-left: 10px;
	background: ${p => p.theme.primary.actionColor};
	color: ${StyleColor.White};
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MenuManager/Left/MenuItem/styles.ts